// Packages and components
import styled from 'styled-components';
import { Box, Layer } from 'grommet';

// Helpers and utilities
import { pxToRem } from '@theme/utils/sizing';

// Constants
const controlHeight = 72;
const modalControlHeight = pxToRem(controlHeight);
const modalBorderRadius = pxToRem(32);

// Styled components

export const StyledLayer: typeof Layer = styled(Layer)`
  border-radius: 0;
  overflow: hidden;

  &.is-height-relative {
    max-width: calc(100% - ${pxToRem(40)});
    border-radius: ${modalBorderRadius};
  }

  /** Large/XLarge */
  &.is-large,
  &.is-xlarge {
    border-radius: ${modalBorderRadius};
  }
`;

export const ModalContainer: typeof Box = styled(Box)`
  max-height: none;
  min-height: 100dvh;
  padding: 0;
  position: relative;

  /** Large/XLarge */
  &.is-large,
  &.is-xlarge {
    max-height: ${pxToRem(800)};
    min-height: initial;
  }

  /** Fixed height */
  &.is-height-fixed.is-large,
  &.is-height-fixed.is-xlarge {
    max-height: ${pxToRem(800)};
    min-height: ${pxToRem(768)};
  }

  /** Relative height */
  &.is-height-relative.is-small,
  &.is-height-relative.is-medium,
  &.is-height-relative.is-large,
  &.is-height-relative.is-xlarge {
    max-height: none;
    min-height: initial;
  }

  /** Confirmation */
  &.is-confirmation {
    max-width: ${pxToRem(350)};
  }

  /** Fixed width */
  &.is-width-fixed {
    max-width: ${pxToRem(512)};
  }
`;

export const ModalControls: typeof Box = styled(Box)`
  background: white;
  height: ${modalControlHeight};
  position: fixed;
  width: 100%;
  z-index: 2;
  &.is-transparent-controls {
    background: transparent;
    z-index: 1;
  }
`;

export const ModalBody: typeof Box = styled(Box)`
  margin-top: calc(${modalControlHeight} - ${pxToRem(27)});
  position: relative;
  z-index: 1;
`;
